import { render, staticRenderFns } from "./ElderlyInsSigning.vue?vue&type=template&id=80faa0c2&scoped=true&"
import script from "./ElderlyInsSigning.vue?vue&type=script&lang=js&"
export * from "./ElderlyInsSigning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80faa0c2",
  null
  
)

export default component.exports